import React from 'react'
import { Box, Chip } from '@mui/material'
import { MY_BUSINESS_ROUTES } from '@constants/routes'
import { dsColorNew } from '@palette'

import MappingAdminPage from '../_shared/MappingAdminPage'

export default function AgencyMappingPage({ embedded = false }) {
	return (
		<MappingAdminPage
			embedded={embedded}
			icon="handshake"
			title={MY_BUSINESS_ROUTES.AGENCY_ADMIN_TITLE}
			subtitle={MY_BUSINESS_ROUTES.AGENCY_ADMIN_SUBTITLE}
			listEndpoint="/api/my-business/admin/agency-mapping"
			rowKey="pms_agency_source_id"
			rowKeyParam="pms_agency_source_id"
			pmsListKey="agencies"
			valueField="ps_master_site_id"
			valueIsNumber
			psOptionLabel={(opt) => (
				<Box display="flex" alignItems="center" gap={0.75}>
					{opt.main && (
						<Chip size="small" label="MAIN" variant="outlined"
						      sx={{ height: 18, fontSize: 11, fontWeight: 700, color: dsColorNew.appBlue, borderColor: dsColorNew.noteInfoBorder, bgcolor: dsColorNew.pillActiveBg }}/>
					)}
					<Box component="span" sx={{ fontWeight: 600 }}>
						{opt.name}
					</Box>
					{opt.domain && (
						<Box component="span" sx={{ color: dsColorNew.textMuted,
						                            fontSize: 13, fontWeight: 500 }}>
							.{opt.domain}
						</Box>
					)}
				</Box>
			)}
			pmsColumns={[
				{ label: 'PMS agency', cell: (r) => (
					<Box sx={{ fontWeight: 600, color: dsColorNew.textTitle }}>{r.name}</Box>
				)},
				{ label: 'PMS source ID', cell: (r) => (
					<Box sx={{ fontSize: 12,
					           color: dsColorNew.textMuted }}>
						{r.pms_agency_source_id}
					</Box>
				)},
			]}
			footerHint="Map each broker/OTA agency in the PMS to the corresponding Price Seeker site. This is the granularity that matters for OTA-level price comparison (rentalcars, autoeurope, discovercars, etc.)."
		/>
	)
}
